import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.15, as = "h1", testId }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.7, delay: delay * 0.3 + i * 0.08, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const InViewMask = ({ text, className = "", as = "h2" }) => {
  const Tag = as;
  return (
    <motion.div initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
      <Tag className={className}>
        <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block"
            variants={{ hide: { y: "100%" }, show: { y: "0%" } }}
            transition={{ duration: 0.9, ease: EASE }}
          >
            {text}
          </motion.span>
        </span>
      </Tag>
    </motion.div>
  );
};
